import script from "./ScheduleByTeams.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleByTeams.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleByTeams.vue?vue&type=style&index=0&id=635715c3&lang=css"

const __exports__ = script;

export default __exports__